import React, {Component} from 'react';
import BackEnd from "../../../backend/BackEnd";
import {successToast} from "../../../utils/toasts";

class Settings extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isLoading: false,
        settings: []
    };
    getSettings = new BackEnd.SettingsAdmin.GetSettings(this);

    async componentWillMount() {
        await this.fetchSettings();
    }

    render() {
        const loadingSpinner = (
            <div className="text-center m-y-2">
                <i className="fa fa-circle-o-notch fa-spin fa-4x text-primary"/>
            </div>
        );

        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-gear-a"/> Система /
                                </span> Настройки
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="panel">
                            <div className="panel-body">
                                {
                                    this.state.isLoading
                                        ? loadingSpinner
                                        : (
                                            <table className="table m-b-0">
                                                <tbody>
                                                {this.state.settings.map(setting =>
                                                    <tr>
                                                        <td className="p-a-2">
                                                            {setting.displayName}
                                                            <br/>
                                                            <small className="text-muted">{setting.key}</small>
                                                        </td>
                                                        <td className="p-a-2 valign-middle">
                                                            <label className="switcher switcher-success">
                                                                <input type="checkbox"
                                                                       checked={setting.value}
                                                                       onChange={event => this.updateSetting(setting.key, event.target.checked)}/>
                                                                <div className="switcher-indicator">
                                                                    <div className="switcher-yes">ВКЛ</div>
                                                                    <div className="switcher-no">ВЫКЛ</div>
                                                                </div>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                        )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    async fetchSettings() {
        const settings = await this.getSettings.call();
        this.setState({settings});
    }

    async updateSetting(settingKey, value) {
        const {settings} = this.state;
        const updateSetting = new BackEnd.SettingsAdmin.UpdateSetting();
        const result = await updateSetting.call({settingKey, value});

        if (result.success) {
            successToast('Настройки успешно сохранены');
            settings.find(setting => setting.key === settingKey).value = value;
            this.setState({settings});
        }
    }
}

export default Settings;


// WEBPACK FOOTER //
// ./src/pages/System/Settings/Settings.js